import { lazy } from 'react'

// Oeffentliche Produkt-Updates unter /product/updates/:slug.
//
// Jedes Update ist eine eigene, lazy geladene Seite: Inhalte, Demos und Styles
// eines Updates landen nur im Chunk dieser Route und nicht im Dashboard-Bundle.
// Assets (Screenshots, Player) liegen unter public/product-updates/<slug>/ und
// muessen eine Endung aus der Amplify-Whitelist haben (png, jpg, svg, js, json
// u. a.). mp4 steht nicht darauf und wuerde auf die index.html umgeschrieben.
//
// Neuestes Update zuerst.
export const PRODUCT_UPDATES = [
  {
    slug: '2026-talentmappe',
    date: '2026-10-28',
    title: 'Ein Talent, eine Datei',
    summary:
      'Die Talentmappe bündelt Stärkenprofil, Passungsprofil und Unterlagen eines Talents in einer PDF. Dein ATS bekommt beide Profile auf Wunsch als eine Datei.',
    Component: lazy(() => import('./2026-talentmappe'))
  },
  {
    slug: '2026-beispieldaten',
    date: '2026-10-07',
    title: 'Beispieldaten erkennen und entfernen',
    summary:
      'Label „Beispiel“ an Stellen und Talenten, Entfernen mit einem Klick und vollständig, eine feste Stelle in den Einstellungen und neue Beispieldaten auf Wunsch.',
    Component: lazy(() => import('./2026-beispieldaten'))
  },
  {
    slug: '2026-kulturmodell',
    date: '2026-09-29',
    title: 'Das neue Kulturmodell',
    summary:
      'Kultur in zehn Unternehmenswerten beschreiben, die neue Challenge „Innerer Kompass“ für Talente und der Abgleich beider Perspektiven im Passungsprofil.',
    Component: lazy(() => import('./2026-kulturmodell'))
  },
  {
    slug: '2026-herbst',
    date: '2026-09-29',
    title: 'Weniger nachfragen. Mehr sehen.',
    summary:
      'Talente verwalten ihr Profil selbst, vollständige Namen in App und Dashboard, Stärken- und Passungsprofil als eine PDF, neu geordnete Talent-Detailseite und eigene Tabellenspalten.',
    Component: lazy(() => import('./2026-herbst'))
  }
]

export const findProductUpdate = (slug) =>
  PRODUCT_UPDATES.find((update) => update.slug === slug)
